<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- CONTENT -->
    <div class="content" [ngClass]="this.view" style="overflow-y: scroll;">

        <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap">
            <div class="card" *ngFor="let bill of virtualReceipts" fxFlex="50">
                <!-- PREVIEW -->
                <div class="card-preview" fxFlex="100">

                    <div class="fuse-card" fxFlex="100">

                        <div class="p-16">
                            <div class="h1">
                                {{bill.customer.firstName}} {{bill.customer.lastName}}<br/>
                                <span *ngIf="bill.customer.phone">{{bill.customer.phone}}<br/></span>
                                <span *ngIf="bill.customer.email">{{bill.customer.email}}<br/></span>
                            </div>
                            <div class="h4 secondary-text">
                                <table>
                                    <tr>
                                        <th style="text-align: left;">{{'Created by'|translate}}</th>
                                        <td style="text-align: left;">{{bill.createdBy.firstName}} {{bill.createdBy.lastName}} ({{bill.createdBy.email}})</td>
                                    </tr>
                                    <tr>
                                        <th style="text-align: left;">{{'Created at'|translate}}</th>
                                        <td style="text-align: left;">{{bill.createdAt|date: 'dd.MM.y HH:mm:ss': 'UTC+2': 'pl'}}</td>
                                    </tr>
                                </table>
                                <table style="width: 100%;">
                                    <tr>
                                        <th colspan="2" style="width: 100%;">{{'Items'|translate}}</th>
                                    </tr>
                                    <tr *ngFor="let billItem of bill.items">
                                        <th *ngIf="billItem.product" style="width: 80%; text-align: left;">{{billItem.product.nameForReceipt}}</th>
                                        <th *ngIf="billItem.voucher" style="width: 80%; text-align: left;">{{billItem.voucher.nameForReceipt}}</th>
                                        <td style="width: 20%; text-align: right;">{{billItem.quantity}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="p-16 pt-0 line-height-1.75">

                        </div>

                        <div class="p-8 pt-0" fxLayout="row" fxLayoutAlign="end center">
                            <div fxLayout="row" fxLayoutAlign="end center">
                                <a mat-button color="accent" routerLink="/pos/{{bill.customer.id}}">{{'PAY'|translate}}</a>

                            </div>
                        </div>

                    </div>

                </div>
                <!-- / PREVIEW -->
            </div>


        </div>
    </div>
</div>
